<h1 mat-dialog-title>Setup Limits</h1>



<div mat-dialog-content style="display: flex;flex-direction: column;">

  <div class="example-full-width" style="display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;margin-top: 12px;margin-bottom: 20px;">
    <mat-label style="font-weight: bold;" class="get-label">{{Title}}</mat-label>
  </div>

  <div>
    <div style="display: flex;justify-content: space-between;align-items: center;">
      <span>0% Worn</span>

      <div>
        <mat-form-field class="header-form-full-width">
          <input placeholder="0% Worn" matInput type="number" matInput [(ngModel)]="worn0Percent" class="get-Input">
        </mat-form-field>
        <i class="material-icons" style="cursor: pointer;" title="The Eval range used is:
  A      0% - 30%
  B  >30% - 50%
  C  >50% - 70%
  X  >70%">info</i>
      </div>
      
    </div>

    <div style="display: flex;justify-content: space-between;margin-top: 6px;align-items: center;">
      <span>100% Worn</span>
      <div style="margin-right: 25px;"> 
        <mat-form-field class="header-form-full-width">
          <input placeholder="100% Worn" matInput type="number" matInput [(ngModel)]="worn100Percent" class="get-Input">
        </mat-form-field>
      </div>
      

    </div>

    <div style="display: flex;justify-content: space-between;margin-top: 6px;align-items: center;">
      <span># of Decimal Places</span>
      <div style="margin-right: 25px;"> 
      <mat-form-field class="header-form-full-width">
        <input placeholder="# of Decimal Places" matInput type="number" matInput [(ngModel)]="NoofDecimal" class="get-Input">
      </mat-form-field>
      </div>

    </div>
  </div>

  

</div>

<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
  <button style="margin-left: 20px;" class="button button--primary" (click)="onSubmitClick()" cdkFocusInitial><span
      class="button__text">Submit</span></button>
</div>